module.exports = __webpack_public_path__ + "static/media/Pranav Pandya.b3822dd3.jpg";